import { splitPhoneParts } from '../phoneLinks.js';

// Un texto de telefonos donde cada numero se puede llamar con un clic.
//
// Lissette, 2026-08-26: *"donde salga algun numero telefonico, como en cliente
// y en company information, que uno pueda marcar/llamar directo dandole clic
// al numero"*.
//
// Se usa SOLO en campos que ya son de telefono. La razon esta en
// `phoneLinks.js`: fuera de ahi, un numero de diez digitos puede ser una
// poliza, y un enlace de llamada sobre una poliza hace marcar a un
// desconocido.
//
// El texto de alrededor —las etiquetas ("Ventas:"), los saltos de linea, las
// extensiones— vuelve intacto, asi que la casilla se sigue leyendo igual que
// antes; lo unico que cambia es que los numeros ahora se pulsan.
//
// `tel:` abre el marcador del sistema (o la aplicacion de escritorio del
// proveedor, si el agente tiene una). Es lo mismo que ya hacia el boton de
// llamar de la ficha, asi que cada agente marca desde su propia linea.
export default function PhoneText({ value, style, linkStyle }) {
  const partes = splitPhoneParts(value);
  if (!partes.length) return null;
  return (
    <span style={style}>
      {partes.map((p, i) => (p.tel ? (
        <a
          key={i}
          href={`tel:${p.tel}`}
          // El clic no debe arrastrar consigo lo que haya detras (abrir una
          // fila, seleccionarla): en una tabla el numero vive dentro de algo
          // que tambien reacciona al clic.
          onClick={(e) => e.stopPropagation()}
          title={`Llamar ${p.text.trim()}`}
          style={{ color: 'var(--c-cyan,#00d4ff)', textDecoration: 'none', borderBottom: '1px dotted currentColor', ...(linkStyle || {}) }}
        >
          {p.text}
        </a>
      ) : (
        // Se conserva tal cual — con sus saltos de linea, que el contenedor
        // pinta con `white-space: pre-wrap`.
        <span key={i}>{p.text}</span>
      )))}
    </span>
  );
}
